// extracted by mini-css-extract-plugin
export default {"description":"style_description__OMmDE","fade-in":"style_fade-in__auaXz","top":"style_top__Mbkmf","image":"style_image__y2p6a"};